var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("line", {
        staticClass: "crm-link",
        attrs: {
          x1: "6.67",
          y1: "2.33",
          x2: "2.33",
          y2: "11",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round"
        }
      }),
      _c("line", {
        staticClass: "crm-link",
        attrs: {
          x1: "6.67",
          y1: "2.33",
          x2: "11",
          y2: "11",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round"
        }
      }),
      _c("circle", {
        staticClass: "crm-node",
        attrs: { cx: "6.67", cy: "2.33", r: "2.33", fill: _vm.color }
      }),
      _c("circle", {
        staticClass: "crm-node",
        attrs: { cx: "2.33", cy: "11", r: "2.33", fill: _vm.color }
      }),
      _c("circle", {
        staticClass: "crm-node",
        attrs: { cx: "11", cy: "11", r: "2.33", fill: _vm.color }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }